const body = document.getElementById('body');
const loader = document.getElementById('js-loader');

let delayFlag = false;
let loadFlag = false;

const setLoad = () => {
	if (delayFlag && loadFlag) {
		body.setAttribute('data-load', true);
	}
};

const loadDelay = loader ? 800 : 0;

setTimeout(() => {
	delayFlag = true;
	setLoad();
}, loadDelay);

window.addEventListener('load', () => {
	loadFlag = true;
	setLoad();
});

// Timeout fallback
if (loader) {
	setTimeout(() => {
		body.setAttribute('data-load', true);
	}, 3000);
} else {
	setTimeout(() => {
		body.setAttribute('data-load', true);
	}, 2000);
}
